module.exports = {
	"header": "Bonnier publishing starts collaboration with Spotin",
	"date": "2022/03/25",
	"imgSrc": "15.jpg",
	"imgAlt": "Bonnier publishing starts collaboration with Spotin",
	"ingress": "By: it-Retail (in Swedish)",
	"externalLink": "https://it-retail.se/tech-bolaget-spotin/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/15/article.json
// module id = 85
// module chunks = 0